export const SectionHeader = ({ kicker, title, intro, align = 'left' }) => {
  const alignCls = align === 'center' ? 'text-center mx-auto' : 'text-left';
  return (
    <div className={`max-w-3xl mb-12 ${alignCls}`}>
      {kicker && (
        <div className="overline mb-4 text-amber">
          <span className="inline-flex items-center gap-2">
            <span className="h-px w-6 bg-amber inline-block" />
            {kicker}
          </span>
        </div>
      )}
      <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-white leading-[1.05] text-balance">
        {title}
      </h2>
      {intro && (
        <p className="mt-5 text-zinc-400 text-base md:text-lg leading-relaxed max-w-2xl">
          {intro}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;
